import { Route, Redirect } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "./Auth";

const PrivateRoute = ({ component: Component, ...rest }) => {
    const { user } = useContext(AuthContext);
    return (
        <Route
            {...rest}
            render={(props) =>
                (user || JSON.parse(localStorage.getItem("user"))) ? <Component {...props} /> : <Redirect to="/sign-in" />
            }
        />
    );
};

export default PrivateRoute;
